/* eslint-disable no-undef */
import { baseApiGatewayUrl } from '../constants/Config';

export default {
  users: {
    onBoard: (requestParams) => {
      //const queryString = `?openIdToken=${requestParams.openIdToken}&accessToken=${requestParams.accessToken}`;
      //const openIdToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6ImY3RHEyV0JrX0dZajJRTmtldzNkVEFSbFB6cyIsImtpZCI6ImY3RHEyV0JrX0dZajJRTmtldzNkVEFSbFB6cyJ9.eyJhdWQiOiIyYmYzYjQyMy04NzdjLTRjMWUtYWYwZS1hNzdjODE2YjliMTgiLCJpc3MiOiJodHRwczovL2dhcy5tY2QuY29tL2FkZnMiLCJpYXQiOjE2MjUwODQyODUsImV4cCI6MTYyNTA4Nzg4NSwiYXV0aF90aW1lIjoxNjI1MDg0Mjg0LCJub25jZSI6IlhuRUVWMWxTeERUc2trb1p2aHNabnciLCJzdWIiOiJsT3BSRlExK3Rud0xmdWJjeG4vOGE4c2JLZjlMSUVMWU9xSFFlajg0QmJNPSIsInVwbiI6Im1pY2hhZWwucmV0emVyQHBhcnRuZXJzLm1jZC5jb20iLCJ1bmlxdWVfbmFtZSI6Ik5BUkVTVFxcZWYwMDE5ODgiLCJwd2RfZXhwIjoiNDgxNzA0MCIsInNpZCI6IlMtMS01LTIxLTE5MDM3Njk0NDItMTc2ODczNjIzNC0yNDc2OTIwMzc3LTc3ODg4IiwiYXRfaGFzaCI6InZvazJuWC1ZMm9DRTNEOUIxcC12WVEifQ.FmTHbJuzfYIAe7RQbC-sr8dijUyZyY7p2W9a3QSfT_w32ZGbaFPTYPPLYbfsf4VQjtq8T_nX9t1Mu0te2ZWETfr8qbfi-rQkebRLHFvJ3FFsUkbWb0dog3V_KxI0v7Z9Z5Sja3tC3WrbHSwye6QLyJbaEGVtsvqiCvixqrIuxSxbyyODHl9Dkg-aTKvZPtdT_g0PTTf6Ripjam6QX0HQHwVNM-FuW6mQ2NKIQLq-rouEqykgGDut9mxYhe5dMPI8semLQoPDSEW7ASAUkeBrckJo8JpkvcYUaVSlycDvsHp3d4RPO9nTBUlPiAsdiMPXILaU9D95XTNy2L1s1MTGoQ"
      
      //const accessToken= "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6ImY3RHEyV0JrX0dZajJRTmtldzNkVEFSbFB6cyJ9.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.IJO3eDijKlmoIuCxj6bFEYIONhBvgvvmrqhFfI8OSDOj9pnPajQ8DTa6vu3hHZLGmED3lr9wsA_EOZw8KOiHLaa5BoueGeZ84rWjoEMDHNj0NWMhwOmbRk1rfZPGnAuXeDeIP9_y9lbgven4ekYLCJ8F8zLnZ5K0MhbNJ36f7Sr8dC1yErXYpCOlg0C6FpP1p7iawiyx2F08ZwLivkm_slBCeaL1HT7qA6vzLvYcrZHukeoDo9ZM1l7GMdzjtQoofwqbV_AHsg70Sp5DqvuIykoiveg5Qw8G23H1sJDt_fTES9MuvjnvimkiEwz2fUAAuqMx6iNgSUQtuTXw0m0LHQ"
      
      
      
      const pload= { openIdToken:requestParams.openIdToken,accessToken:requestParams.accessToken  }
      
      //const pload= { openIdToken:openIdToken,accessToken:accessToken  }
      
      return fetch(`${baseApiGatewayUrl}UserOnboardRequest`, {

        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pload),
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        return false;
      });
    },
    saveUserDetails: (requestParams) => {
      //const queryString = `?accessToken=${requestParams.accessToken}`;
      const pload= { accessToken:requestParams.accessToken

      }
      return fetch(`${baseApiGatewayUrl}WriteUserDetailsInDB`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pload),
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        return false;
      });
    },
  },
  favorites: {
    getFavorites: (requestParams) => {
      //const queryString = `?identityRegion=${requestParams.identityRegion}&dashboardRegion=${requestParams.dashboardRegion}&openIdToken=${requestParams.openIdToken}&accessToken=${requestParams.accessToken}`;
      const pload= { openIdToken:requestParams.openIdToken,
        accessToken:requestParams.accessToken,
        identityRegion:requestParams.identityRegion,
        dashboardRegion:requestParams.dashboardRegion

      }
    
      return fetch(`${baseApiGatewayUrl}GetUserFavorites`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pload),
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        return false;
      });
    },
    addFavorites: (requestParams) => (
      fetch(`${baseApiGatewayUrl}GetUserFavorites`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestParams),
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        return false;
      })
    ),
    deleteFavorite: (requestParams) => (
      fetch(`${baseApiGatewayUrl}GetUserFavorites`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestParams),
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        return false;
      })
    ),
  },
  userGuide: (requestParams) => {
    //const queryString = `?identityRegion=${requestParams.identityRegion}&dashboardRegion=${requestParams.dashboardRegion}&openIdToken=${requestParams.openIdToken}&accessToken=${requestParams.accessToken}`;
    const pload= { openIdToken:requestParams.openIdToken,
        accessToken:requestParams.accessToken,
        identityRegion:requestParams.identityRegion,
        dashboardRegion:requestParams.dashboardRegion

      }
    return fetch(`${baseApiGatewayUrl}GetUserGuide`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(pload),
    }).then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      return false;
    });
  },
  whatsNew: (requestParams) => {
    //const queryString = `?identityRegion=${requestParams.identityRegion}&dashboardRegion=${requestParams.dashboardRegion}&openIdToken=${requestParams.openIdToken}&accessToken=${requestParams.accessToken}`;
    const pload= { openIdToken:requestParams.openIdToken,
        accessToken:requestParams.accessToken,
        identityRegion:requestParams.identityRegion,
        dashboardRegion:requestParams.dashboardRegion

      }
    return fetch(`${baseApiGatewayUrl}GetWhatsNew`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(pload),
    }).then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      return false;
    });
  },
  faqs: (requestParams) => {
    //const queryString = `?identityRegion=${requestParams.identityRegion}&dashboardRegion=${requestParams.dashboardRegion}&openIdToken=${requestParams.openIdToken}&accessToken=${requestParams.accessToken}`;
    const pload= { openIdToken:requestParams.openIdToken,
        accessToken:requestParams.accessToken,
        identityRegion:requestParams.identityRegion,
        dashboardRegion:requestParams.dashboardRegion

      }
    return fetch(`${baseApiGatewayUrl}GetFAQs`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(pload),
    }).then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      return false;
    });
  },
  reports: {
    requestReport: (requestParams) => (
      fetch(`${baseApiGatewayUrl}RequestReport`, {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestParams),
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        return false;
      })
    ),
  },
  dashboard: {
    getDashboardList: (requestParams) => {
      //const queryString = `?identityRegion=${requestParams.identityRegion}&dashboardRegion=${requestParams.dashboardRegion}&openIdToken=${requestParams.openIdToken}&accessToken=${requestParams.accessToken}`;
      const pload= { openIdToken:requestParams.openIdToken,
        accessToken:requestParams.accessToken,
        identityRegion:requestParams.identityRegion,
        dashboardRegion:requestParams.dashboardRegion

      }
      return fetch(`${baseApiGatewayUrl}GetDashboardList`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pload),
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        return false;
      });
    },
    getSessionEmbeddedUrl: (requestParams) => {
      //const queryString = `?resetDisabled=true&undoRedoDisabled=true&dashboardId=${requestParams.dashboardId}&dashboardRegion=${requestParams.dashboardRegion}&openIdToken=${requestParams.openIdToken}&accessToken=${requestParams.accessToken}&entryPoint=/start/dashboards`;
      const pload= { openIdToken:requestParams.openIdToken,
        accessToken:requestParams.accessToken,
        identityRegion:requestParams.identityRegion,
        dashboardRegion:requestParams.dashboardRegion,
        printEnabled: true,
        resetDisabled: false,
        undoRedoDisabled: false,
        dashboardId:requestParams.dashboardId,
        entryPoint:'/start/dashboards'
      }
      return fetch(`${baseApiGatewayUrl}GetDashboardEmbedUrl`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pload),
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        return false;
      });
    },
    getSageMakerUrl: (requestParams) => {
      //const queryString = `?resetDisabled=true&undoRedoDisabled=true&dashboardId=absc-12323&dashboardRegion=${requestParams.dashboardRegion}&openIdToken=${requestParams.openIdToken}&accessToken=${requestParams.accessToken}&entryPoint=/start/dashboards`;
      const pload= { openIdToken:requestParams.openIdToken,
        accessToken:requestParams.accessToken,
        identityRegion:requestParams.identityRegion,
        dashboardRegion:requestParams.dashboardRegion,
        printEnabled: true,
        resetDisabled: false,
        undoRedoDisabled: false,
        dashboardId:requestParams.dashboardId,
        entryPoint:'/start/dashboards'
      }
      
      return fetch(`${baseApiGatewayUrl}sagemaker`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pload),
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        return false;
      });
    },
  },
};
